import { ApiKey, ApiPathManager } from "app/shared/services/api-path";
import { getDataHeaders, getUserHeader } from "app/shared/services/header-builder";
import { REQUESTINPUT } from "app/shared/services/services-model.type";
import { instance } from "app/shared/util/token-store";
import { FetchAddBeneProfileRequest, FetchAddBeneTemplateRequest, FetchListBeneRequest } from "../reducer/types";

export const LIMIT_BENE = 20;

/** Lấy danh sách thụ hưởng */
export const fetchListBeneService = async (actionRq: FetchListBeneRequest) => {
  const { action, massageID, url } = ApiPathManager(ApiKey.GET_PROFILES);
  const header = getDataHeaders(massageID, action);
  const userProfile = getUserHeader();
  const requestInput: REQUESTINPUT = {
    USERPROFILE: userProfile,
    STATUS: "2",
    OFFSET: String(actionRq?.payload?.offset || 0),
    LIMIT: String(actionRq?.payload?.limit || LIMIT_BENE),
    TEMPLATE: { TEMPLATE_TYPE: actionRq?.payload?.templateType || "" },
    TRANSPROFILE: {
      NAME: actionRq?.payload?.searchKey,
    },
    TEMPLATE_META: {
      META_KEY: "",
      META_VALUE: "",
    },
  };
  const body = {
    HEADER: header,
    REQUESTINPUT: requestInput,
  };
  console.log("body: ", body);
  const response: any = await instance.post(url, body);
  return response;
};

/** Add thụ hưởng */
export const fetchAddBeneProfileService = async (actionRq: FetchAddBeneProfileRequest) => {
  const { action, massageID, url } = ApiPathManager(ApiKey.CREATE_PROFILE);
  const header = getDataHeaders(massageID, action);
  const userProfile = getUserHeader();
  const requestInput: REQUESTINPUT = {
    USERPROFILE: userProfile,
    TRANSPROFILE: {
      NAME: actionRq.payload?.profile?.NAME || "",
      AVATAR: actionRq.payload?.profile?.AVATAR || "",
    },
  };
  const body = {
    HEADER: header,
    REQUESTINPUT: requestInput,
  };
  console.log("body: ", body);
  const response: any = await instance.post(url, body);
  return response;
};

/** Add thụ hưởng */
export const fetchAddBeneTemplateService = async (actionRq: FetchAddBeneTemplateRequest) => {
  const { action, massageID, url } = ApiPathManager(ApiKey.CREATE_TEMPLATE);
  const header = getDataHeaders(massageID, action);
  const userProfile = getUserHeader();
  const requestInput: REQUESTINPUT = {
    USERPROFILE: userProfile,
    TEMPLATE: actionRq.payload,
  };
  const body = {
    HEADER: header,
    REQUESTINPUT: requestInput,
  };
  console.log("body: ", body);
  const response: any = await instance.post(url, body);
  return response;
};
